import { CLOUDFRONT_URL } from '../../utils/urls';
import { GeneralPayments } from './types';

const generalPayments: GeneralPayments = {
  fintoc: {
    slug: '1',
    logo: `${CLOUDFRONT_URL}/payment-gateway/t1/logo-fintoc_horizontal.svg`,
    title: 'Paga con tu banco usando Fintoc',
    description: 'Pague con su banco usando la aplicación Fintoc',
    id: '1',
    name: 'fintoc-default',
    maximum: '',
    minPrice: 0,
    maxPrice: 0,
    position: 0,
    handler: 'fintoc',
  },
  oneClick: {
    slug: '2',
    logo: `${CLOUDFRONT_URL}/payment-gateway/t1/logo-webpay_oneclick_horizontal.png`,
    title: 'WebPay OneClick',
    description: 'Paga directo con tu tarjeta',
    id: '2',
    name: 'oneclick-default',
    maximum: '',
    minPrice: 0,
    maxPrice: 0,
    position: 0,
    handler: 'oneClick',
  },
  webPayDeb: {
    slug: '3',
    logo: `${CLOUDFRONT_URL}/payment-gateway/t1/logo-redcompra.png`,
    title: 'Paga con débito',
    description: 'Paga a través de WebPay',
    id: '3',
    name: 'webpay-default',
    maximum: '',
    minPrice: 0,
    maxPrice: 0,
    position: 0,
    handler: 'webPay',
  },
  khipu: {
    slug: '4',
    logo: `${CLOUDFRONT_URL}/payment-gateway/t1/logo-khipu.svg`,
    title: 'Paga con tu banco usando Khipu',
    description: 'Pague con su banco usando la aplicación Khipu',
    id: '4',
    name: 'khipu-default',
    maximum: '',
    minPrice: 0,
    maxPrice: 0,
    position: 0,
    handler: 'khipu',
  },
  webPayCred: {
    slug: '5',
    logo: `${CLOUDFRONT_URL}/payment-gateway/t1/logo-credito.png`,
    title: 'Paga con tarjeta de crédito',
    description: 'Paga a través de WebPay',
    id: '5',
    name: 'webpay-default',
    maximum: '',
    minPrice: 0,
    maxPrice: 0,
    position: 0,
    handler: 'webPay',
  },
  etpay: {
    slug: '6',
    logo: `${CLOUDFRONT_URL}/payment-gateway/t1/logo-etpay_horizontal.svg`,
    title: 'Paga con tu banco usando ETPay',
    description: 'Pague con su banco usando la aplicación ETPay',
    id: '6',
    name: 'etpay-default',
    maximum: '',
    minPrice: 0,
    maxPrice: 0,
    position: 0,
    handler: 'etpay',
  },
  mach: {
    slug: '7',
    logo: `${CLOUDFRONT_URL}/payment-gateway/t1/logo-mach_horizontal.svg`,
    title: 'Paga con tu tarjeta MACH',
    description: 'Pague con su tarjeta MACH',
    id: '7',
    name: 'mach-default',
    maximum: '',
    minPrice: 0,
    maxPrice: 0,
    position: 0,
    handler: 'mach',
  },
  prontopaga: {
    slug: '8',
    logo: `${CLOUDFRONT_URL}/payment-gateway/t1/logo-prontopaga_horizontal.svg`,
    title: 'Transfiere via ProntoPaga',
    description: 'Transfiere via ProntoPaga',
    id: '8',
    name: 'prontopaga-default',
    maximum: '',
    minPrice: 0,
    maxPrice: 0,
    position: 0,
    handler: 'prontopaga',
  },
  tef: {
    slug: '9',
    logo: `${CLOUDFRONT_URL}/payment-gateway/t1/logo-tef_horizontal.svg`,
    title: 'Paga con tu banco',
    description: 'Paga con tu banco',
    id: '9',
    name: 'tef-default',
    maximum: '',
    minPrice: 0,
    maxPrice: 0,
    position: 0,
    handler: 'tef',
  },
};

export default generalPayments;
